import ClientPaymentRefundItem from '../../../Domain/ClientPaymentRefundItem';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ClientPaymentRefundService from '../../../Services/ClientPaymentRefundService';
import React from 'react';

export default class ClientPaymentDetailsRefundTab extends React.Component {
  static defaultProps = {
    clientPaymentId: 0
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: props.clientPaymentId
    };
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={ClientPaymentRefundItem}
          serviceFunction={ClientPaymentRefundService.GetListBySearching}
          convertDBItemsFunction={ClientPaymentRefundService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderBy='Reason'
          errorCode='CPDRT23'
        />
      </div>
    );
  }
}
